function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m431.715 80.857h-351.43a72.367 72.367 0 0 0 -72.285 72.285v205.716a72.367 72.367 0 0 0 72.285 72.285h351.43a72.367 72.367 0 0 0 72.285-72.285v-205.716a72.367 72.367 0 0 0 -72.285-72.285zm0 16a55.955 55.955 0 0 1 31.171 9.448l-206.886 174.376-206.886-174.376a55.955 55.955 0 0 1 31.171-9.448zm-407.715 56.285a56.026 56.026 0 0 1 13.094-36.042l158.877 133.91-159.543 143.069a56 56 0 0 1 -12.428-35.221zm56.285 262a55.956 55.956 0 0 1 -32.116-10.1l160.156-143.619 42.519 35.837a8 8 0 0 0 10.312 0l40.051-33.76 162.24 141.812a55.956 55.956 0 0 1 -31.732 9.828zm407.715-56.284a56.017 56.017 0 0 1 -12.7 35.567l-161.717-141.354 161.322-135.971a56.026 56.026 0 0 1 13.095 36.042z",
    fill: "#000000",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.18a6157f63920396c197f6694ef6922e.svg";
export { ForwardRef as ReactComponent };